import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { format } from "date-fns";
import { Button, Stack } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#545454",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
    },
}));

const FilterButton = styled(Button)`
    text-transform: capitalize;
    font-size: 11px;
    color: ${({ theme, id, filterBy }) => {
        if (id === filterBy) return theme.palette.primary.main;
        if (id !== filterBy) return theme.palette.text.disabled;
        return null;
    }};
`;

const MissionsHistoryTeamsTable = ({ missions }) => {
    if (!missions || missions.length === 0)
        return (
            <p style={{ fontSize: "12px", padding: "62px" }}>No missions history at the moment</p>
        );
    const [filterByStatus, setFilterByStatus] = React.useState("all");
    const [filterByCategory, setFilterByCategory] = React.useState("all");
    const [missionsHistory, setMissionsHistoryTeams] = React.useState(missions);
    const createData = (name, started, finished, status, attempts, size, category) => {
        return { name, started, finished, status, attempts, size, category };
    };

    React.useEffect(() => {
        let tempMissions = missions;
        if (filterByStatus !== "all") {
            tempMissions = tempMissions.filter((item) => item.status.includes(filterByStatus));
        }
        if (filterByCategory !== "all") {
            tempMissions = tempMissions.filter((item) => item.category.includes(filterByCategory));
        }
        setMissionsHistoryTeams(tempMissions);
    }, [filterByStatus, filterByCategory]);

    const rows = missionsHistory.map((mission) => {
        return createData(
            mission.title,
            mission.startDate,
            mission.endDate,
            mission.status,
            mission.attempts,
            mission.teamMembers,
            mission.category
        );
    });

    const stringFormatter = (str) => {
        const words = str.replace(/([A-Z])/g, " $1");
        const formattedWords = words.charAt(0).toUpperCase() + words.slice(1);
        return formattedWords;
    };
    return (
        <>
            <Stack direction="row" style={{ width: "100%" }} p={1}>
                <p style={{ fontSize: "11px" }}>Status:</p>
                <FilterButton
                    id="all"
                    filterBy={filterByStatus}
                    onClick={() => setFilterByStatus("all")}
                >
                    All
                </FilterButton>
                <FilterButton
                    id="in-progress"
                    filterBy={filterByStatus}
                    onClick={() => setFilterByStatus("in-progress")}
                >
                    In progress
                </FilterButton>
                <FilterButton
                    id="succeeded"
                    filterBy={filterByStatus}
                    onClick={() => setFilterByStatus("succeeded")}
                >
                    Succeeded
                </FilterButton>
                <FilterButton
                    id="failed"
                    filterBy={filterByStatus}
                    onClick={() => setFilterByStatus("failed")}
                >
                    Failed
                </FilterButton>
                <FilterButton
                    id="aborted"
                    filterBy={filterByStatus}
                    onClick={() => setFilterByStatus("aborted")}
                >
                    Aborted
                </FilterButton>
                <p style={{ fontSize: "11px", paddingLeft: "26px" }}>Category:</p>
                <FilterButton
                    id="all"
                    filterBy={filterByCategory}
                    onClick={() => setFilterByCategory("all")}
                >
                    All
                </FilterButton>
                <FilterButton
                    id="work"
                    filterBy={filterByCategory}
                    onClick={() => setFilterByCategory("work")}
                >
                    Work
                </FilterButton>
                <FilterButton
                    id="collaboration"
                    filterBy={filterByCategory}
                    onClick={() => setFilterByCategory("collaboration")}
                >
                    Collaboration
                </FilterButton>
                <FilterButton
                    id="wellbeing"
                    filterBy={filterByCategory}
                    onClick={() => setFilterByCategory("wellbeing")}
                >
                    Wellbeing
                </FilterButton>
            </Stack>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <TableContainer sx={{ maxHeight: 640 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Mission</StyledTableCell>
                                <StyledTableCell align="center">Date started</StyledTableCell>
                                <StyledTableCell align="center">Date finished</StyledTableCell>
                                <StyledTableCell align="center">Status</StyledTableCell>
                                <StyledTableCell align="center">Attempted</StyledTableCell>
                                <StyledTableCell align="center">Category</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow
                                    key={row.missionId + row.startDate}
                                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                    <StyledTableCell component="th" scope="row">
                                        {row.name}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {format(new Date(row.started * 1000), "dd/MM/yyyy")}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {format(new Date(row.finished * 1000), "dd/MM/yyyy")}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        {stringFormatter(row.status)}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{row.attempts}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        {stringFormatter(row.category)}
                                    </StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    );
};

export default MissionsHistoryTeamsTable;
